import { useState } from 'react'
import infoCircleSvg from '../../../assets/images/icons/info_circle.svg'
import { Icon, Tooltip } from '../../atoms'
import { TooltipContent, TooltipTrigger } from '../../atoms/Tooltip'
import { tooltipTriggerStyle } from './index.css'

export const InfoCircle = (props: { tooltip: string }) => {
  const [open, setOpen] = useState(false)
  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
    >
      <TooltipTrigger
        className={tooltipTriggerStyle}
        onClick={() => setOpen((state) => !state)}
      >
        <Icon
          src={infoCircleSvg}
          analytic={{
            name: 'tooltip',
          }}
        />
      </TooltipTrigger>
      <TooltipContent>{props.tooltip}</TooltipContent>
    </Tooltip>
  )
}
